export default __webpack_public_path__ + "images/c729605aeebe689283f41e86eeda4e9e-comm_1.png";